import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import 'flowbite';


// Import Swiper core and required modules
import Swiper, {Navigation, Pagination} from 'swiper';

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Target all media containers with the specific classes


// Target the chug-text.svg element
gsap.registerPlugin(ScrollTrigger);


// Target all elements with the class `chug__text`
// document.querySelectorAll('.chug__text').forEach((chugText) => {
//     gsap.to(chugText, {
//         rotation: 90, // Rotate slower (reduce the degree of rotation for the same scroll distance)
//         ease: "power1.out", // Smooth easing
//         scrollTrigger: {
//             trigger: chugText.closest('.chug-section'), // Trigger the rotation on the parent section
//             start: "top bottom", // Start when the section enters the viewport
//             end: "bottom top+=500", // Extend the scroll distance for slower rotation
//             scrub: true, // Sync the rotation with scroll
//         },
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".reviews-carousel").forEach((parent) => {
        const swiperContainer = parent.querySelector(".swiper-container");
        const swiperElement = swiperContainer.querySelector(".reviews");
        const nextButton = swiperContainer.querySelector(".custom-swiper-button-next");
        const prevButton = swiperContainer.querySelector(".custom-swiper-button-prev");

        if (swiperElement && nextButton && prevButton) {
            const swiper = new Swiper(swiperElement, {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    768: { slidesPerView: 2, spaceBetween: 30 },
                    1200: { slidesPerView: 3, spaceBetween: 30 },
                },
                on: {
                    init: function () {
                        updateButtonState(this);
                    },
                    slideChange: function () {
                        updateButtonState(this);
                    },
                },
            });

            function updateButtonState(swiper) {
                prevButton.classList.toggle("opacity-50", swiper.isBeginning);
                prevButton.classList.toggle("cursor-not-allowed", swiper.isBeginning);

                nextButton.classList.toggle("opacity-50", swiper.isEnd);
                nextButton.classList.toggle("cursor-not-allowed", swiper.isEnd);
            }

            // If buttons are still not working, re-add event listeners
            nextButton.addEventListener("click", () => swiper.slideNext());
            prevButton.addEventListener("click", () => swiper.slidePrev());
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".custom-products-swiper")) {
        new Swiper(".custom-products-swiper", {
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
});




import './functions/swiper';
import './functions/smoothScroll';
import './functions/navOverlay';

import '../scss/styles.scss';
